/**
 * Opens a theme-owned email modal for .klaviyo-bis-trigger clicks on pages
 * where Klaviyo onsite.js does not bind (anything other than /products/ or
 * /collections/). Posts to Klaviyo's Client Back in Stock API.
 */
(function () {
  var REVISION = '2024-06-15';
  var modal = document.getElementById('ozlo-bis-modal');
  if (!modal) return;

  var form = modal.querySelector('.ozlo-bis__form');
  var emailInput = document.getElementById('ozlo-bis-email');
  var statusEl = modal.querySelector('.ozlo-bis__status');
  var submitBtn = modal.querySelector('.ozlo-bis__submit');
  var lastFocus = null;
  var variantId = '';

  function klaviyoHandlesThisPage() {
    var path = window.location.pathname || '';
    return /\/products\//.test(path) || /\/collections\//.test(path);
  }

  function getCompanyId() {
    var fromSetting = (modal.getAttribute('data-company-id') || '').trim();
    if (fromSetting) return fromSetting;

    var scripts = document.querySelectorAll('script[src*="klaviyo"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var url = new URL(scripts[i].src, window.location.origin);
        var q = url.searchParams.get('company_id');
        if (q) return q;
        var match = url.pathname.match(/\/onsite\/js\/([^/]+)\//);
        if (match) return match[1];
      } catch (e) {
        /* ignore malformed src */
      }
    }
    return '';
  }

  function setStatus(message) {
    if (!statusEl) return;
    if (!message) {
      statusEl.hidden = true;
      statusEl.textContent = '';
      return;
    }
    statusEl.hidden = false;
    statusEl.textContent = message;
  }

  function openModal(trigger) {
    variantId = (trigger.getAttribute('data-variant-id') || '').trim();
    lastFocus = document.activeElement;
    modal.classList.remove('is-loading', 'is-success');
    modal.hidden = false;
    if (form) form.hidden = false;
    var success = modal.querySelector('.ozlo-bis__success');
    if (success) success.hidden = true;
    setStatus('');
    if (emailInput) {
      emailInput.value = emailInput.value || '';
      emailInput.focus();
    }
    document.body.classList.add('ozlo-bis-open');
  }

  function closeModal() {
    modal.hidden = true;
    modal.classList.remove('is-loading', 'is-success');
    document.body.classList.remove('ozlo-bis-open');
    variantId = '';
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function showSuccess() {
    modal.classList.remove('is-loading');
    modal.classList.add('is-success');
    var success = modal.querySelector('.ozlo-bis__success');
    if (success) success.hidden = false;
    if (form) form.hidden = true;
    setStatus('');
    var closeBtn = modal.querySelector('.ozlo-bis__success [data-ozlo-bis-close]');
    if (closeBtn) closeBtn.focus();
  }

  function subscribe(email) {
    var companyId = getCompanyId();
    if (!companyId) {
      setStatus(modal.getAttribute('data-error'));
      return Promise.resolve(false);
    }
    if (!variantId) {
      setStatus(modal.getAttribute('data-error'));
      return Promise.resolve(false);
    }

    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId
            }
          }
        }
      }
    };

    return fetch(
      'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(companyId),
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: REVISION
        },
        body: JSON.stringify(payload)
      }
    ).then(function (res) {
      if (res.status === 202 || res.status === 204 || res.ok) return true;
      return res.json().catch(function () { return {}; }).then(function (body) {
        var detail = body && body.errors && body.errors[0] && body.errors[0].detail;
        throw new Error(detail || modal.getAttribute('data-error'));
      });
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      if (klaviyoHandlesThisPage()) return;
      var trigger = event.target.closest && event.target.closest('.klaviyo-bis-trigger');
      if (!trigger) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      openModal(trigger);
    },
    true
  );

  modal.addEventListener('click', function (event) {
    if (event.target.closest('[data-ozlo-bis-close]')) {
      event.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) closeModal();
  });

  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = (emailInput && emailInput.value ? emailInput.value : '').trim();
      if (!email || (emailInput && !emailInput.checkValidity())) {
        setStatus(modal.getAttribute('data-invalid-email'));
        if (emailInput) emailInput.focus();
        return;
      }

      modal.classList.add('is-loading');
      if (submitBtn) submitBtn.disabled = true;
      setStatus('');

      subscribe(email)
        .then(function (ok) {
          if (submitBtn) submitBtn.disabled = false;
          if (ok) showSuccess();
          else modal.classList.remove('is-loading');
        })
        .catch(function (err) {
          modal.classList.remove('is-loading');
          if (submitBtn) submitBtn.disabled = false;
          setStatus((err && err.message) || modal.getAttribute('data-error'));
        });
    });
  }
})();
